import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import TooltipButton from '../shared/TooltipButton';
import Tr from '../shared/tr';
import PrevIcon from '../../assets/image/toolbar/arrow_left.svg';
import PrevIconDisabled from '../../assets/image/toolbar/arrow_left_disabled.svg';
import NextIcon from '../../assets/image/toolbar/arrow_right.svg';
import NextIconDisabled from '../../assets/image/toolbar/arrow_right_disabled.svg';
import DownloadIcon from '../../assets/image/toolbar/download.svg';
import DeleteIcon from '../../assets/image/toolbar/delete.svg';
import Util from '../shared/util';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      pointerEvents: 'none',
    },
    button: {
      borderRadius: '50%',
      width: 32,
      height: 32,
      border: 'none',
      background: '#E2F8FC',
      '&:hover': {
        background: 'rgba(54, 176, 201, 1)',
      },
      '&:disabled': {
        background: '#E2F8FC',
      },
      pointerEvents: 'all',
    },
    toolbar: {
      pointerEvents: 'none',
    },
  })
);

export default function GalleryCanvasToolbar(props: GalleryCanvasToolbarProps) {
  const classes = useStyles();
  const href = props.imgSrc;
  const download = 'CSWebViewer_' + Util.formatCurrentDate() + '.png';
  const nextIcon = props.nextAvailable ? NextIcon : NextIconDisabled;
  const prevIcon = props.prevAvailable ? PrevIcon : PrevIconDisabled;
  const separator = <div style={{ width: 70 }} />;

  const tr = new Tr();
  const trPrevious = tr.galleryPrevious();
  const trNext = tr.galleryNext();
  const trDownload = tr.galleryDownload();
  const trDelete = tr.galleryDelete();

  return (
    <div className={classes.root}>
      <Toolbar className={classes.toolbar}>
        <TooltipButton
          className={classes.button}
          title={trPrevious}
          imgSrc={prevIcon}
          disabled={!props.prevAvailable}
          onClick={() => {
            if (props && props.onPrev) {
              props.onPrev();
            }
          }}
          name="galleryToolbar.btnShowPrev"
        />
        {separator}
        <TooltipButton
          className={classes.button}
          title={trNext}
          imgSrc={nextIcon}
          disabled={!props.nextAvailable}
          onClick={() => {
            if (props && props.onNext) {
              props.onNext();
            }
          }}
          name="galleryToolbar.btnShowNext"
        />
        {separator}
        <a href={href} download={download} style={{ textDecoration: 'none' }}>
          <TooltipButton
            className={classes.button}
            title={trDownload}
            imgSrc={DownloadIcon}
            name="galleryToolbar.btnDownload"
          />
        </a>
        {separator}
        <TooltipButton
          className={classes.button}
          title={trDelete}
          imgSrc={DeleteIcon}
          onClick={() => {
            if (props && props.onDelete) {
              props.onDelete();
            }
          }}
          name="galleryToolbar.btnDelete"
        />
      </Toolbar>
    </div>
  );
}

interface GalleryCanvasToolbarProps {
  imgSrc: string;
  prevAvailable: boolean;
  nextAvailable: boolean;
  onPrev?: () => void;
  onNext?: () => void;
  onDelete?: () => void;
}
